import { createStore, applyMiddleware } from 'redux';
import promise from 'redux-promise';
import reduxThunk from 'redux-thunk'
import reducers from './reducers';

// redux-promise auto resolves the promise
const createStoreWithMiddleware = applyMiddleware(promise, reduxThunk)(createStore);
const appStore = createStoreWithMiddleware(reducers);

export default appStore;


// WEBPACK FOOTER //
// ./src/store.js